"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTotalSelectedQuantity = exports.getRemainingQuantityPerPoints = exports.getRemainingQuantityPerAmount = exports.getRemainingQuantity = exports.getRemainingItemQuantity = exports.getRemainingAmount = void 0;
const getTotalSelectedQuantity = selectedOfferItems => selectedOfferItems.reduce((acc, offerItem) => acc + offerItem.quantity, 0);
exports.getTotalSelectedQuantity = getTotalSelectedQuantity;
const getRemainingItemQuantity = ({
  maxItemQuantityToBuy,
  quantity
}) => maxItemQuantityToBuy === undefined ? Number.POSITIVE_INFINITY : maxItemQuantityToBuy - quantity;
exports.getRemainingItemQuantity = getRemainingItemQuantity;
const getRemainingQuantityPerAmount = ({
  amount,
  remainingAmount
}) => remainingAmount === undefined || amount === 0 ? Number.POSITIVE_INFINITY : Math.floor(remainingAmount / amount);
exports.getRemainingQuantityPerAmount = getRemainingQuantityPerAmount;
const getRemainingQuantityPerPoints = ({
  isCampaignOffer,
  availablePoints,
  points
}) => !isCampaignOffer || availablePoints === null || points === 0 ? Number.POSITIVE_INFINITY : Math.floor(Number(availablePoints) / points);
exports.getRemainingQuantityPerPoints = getRemainingQuantityPerPoints;
const getRemainingAmount = ({
  maxAmountToSpend,
  selectedItemsTotalAmount
}) => maxAmountToSpend === null ? undefined : maxAmountToSpend - (selectedItemsTotalAmount ?? 0);
exports.getRemainingAmount = getRemainingAmount;
const getRemainingQuantity = ({
  maxQuantityToBuy,
  maxProductQuantity,
  totalSelectedQuantity
}) => maxQuantityToBuy === null ? maxProductQuantity - totalSelectedQuantity : maxQuantityToBuy - totalSelectedQuantity;
exports.getRemainingQuantity = getRemainingQuantity;